"use client";

import { useParams } from "next/navigation";
import { useEffect, useState } from "react";

const getHash = () => (typeof window !== "undefined" ? window.location.hash : undefined);

export const useHash = (): string | undefined => {
    const [{ isClient, hash }, setState] = useState<{ hash?: string; isClient: boolean }>({
        isClient: false,
    });

    const params = useParams();

    useEffect(() => {
        setState({
            isClient: true,
            hash: getHash(),
        });
    }, [params]);

    return isClient ? (hash?.replace("#", "") ?? "") : undefined;
};
